<template>
  <div
    class="modal fade"
    ref="modal"
    tabindex="-1"
    aria-labelledby="confirmAction"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">
            {{ 'Edit' | translate }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label" :for="`post_title_${post.id}`">
              {{ 'Title' | translate }}
            </label>
            <input
              class="form-control"
              v-model="post.title"
              type="text"
              name="title"
              :id="`post_title_${post.id}`"
            />
          </div>
          <div class="mb-3">
            <label class="form-label" :for="`post_body_${post.id}`">
              {{ 'Content' | translate }}
            </label>
            <textarea
              class="form-control"
              v-model="post.body"
              name="content"
              :id="`post_body_${post.id}`"
            ></textarea>
          </div>
          <div class="mb-3" v-if="showVideoUpload">
            <input
              id="video-url"
              name=""
              type="text"
              class="form-control"
              v-model="post.video"
              placeholder="Embed url (Vimeo, YouTube)"
            />
          </div>
          <div>
            <button
              class="btn btn-link btn-sm"
              @click="toggleVideoUpload"
              v-if="showVideoUpload"
            >
              <i class="fas fa-times" v-if="showVideoUpload"></i>
              <i class="far fa-play-circle" v-else></i>
            </button>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            {{ 'Cancel' | translate }}
          </button>
          <button type="button" :class="['btn', 'btn-primary', isValid ? '' : 'disabled']" @click="save">
            {{ 'Save' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Select from 'vue-select'

export default {
  components: {
    Select,
  },
  props: ['post'],
  data() {
    return {
      modal: null,
      showImageUpload: false,
      showVideoUpload: false,
    }
  },
  mounted() {
    this.modal = new bootstrap.Modal(this.$refs.modal)
  },
  computed: {
    isValid() {
      if (
        this.post.title.length < 5 ||
        this.post.title.length > 159
      ) {
        return false
      }

      if (
        this.post.body.length < 5
      ) {
        return false
      }

      return true
    },
  },
  methods: {
    storeImage(file) {
      this.post.image = file
    },
    deleteImage() {
      this.post.image = null
    },
    toggleImageUpload() {
      this.showImageUpload = !this.showImageUpload
    },
    toggleVideoUpload() {
      this.showVideoUpload = !this.showVideoUpload
    },
    show() {
      this.modal.show()
    },
    hide() {
      this.modal.hide()
    },
    save() {
      axios
        .put(`/json/community/posts/${this.post.id}`, this.post)
        .then(({ data }) => {
          this.$emit('postEdited', data)
          this.hide()
        })
    },
  },
}
</script>
